import Image from 'next/image';
import React from 'react';

import { type GalleryImage as GalleryImageType } from '@/types/gallery';

const GalleryImage: React.FC<GalleryImageType> = ({ src, alternativeText = '', width, height }) => (
  <picture className="gallery-media">
    <Image
      alt={alternativeText || 'Gallery image'}
      decoding="async"
      height={height}
      loading="eager"
      src={src}
      width={width}
      priority
    />
  </picture>
);

export default GalleryImage;
